import { Alerta, Button, Card, Spinner, Stack, TextField } from "@/components";
import type { FormFideicomiso } from "@/lib/fideicomisos";
import { useConfigFideicomisoTab } from "./useConfigFideicomisoTab";

export function ConfigFideicomisoTab() {
  const t = useConfigFideicomisoTab();
  const campo = (clave: keyof FormFideicomiso) => ({
    value: t.form?.[clave] ?? "",
    onChange: (e: { target: { value: string } }) => t.cambiar(clave, e.target.value),
    error: t.errores[clave] ?? null,
  });

  return (
    <Stack espacio={6}>
      <h1 className="text-pantalla font-light tracking-[-0.03em]">Datos del fideicomiso</h1>
      {t.cargando && (
        <div className="grid place-items-center py-10 text-primario">
          <Spinner />
        </div>
      )}
      {t.errorCarga && (
        <Card>
          <Stack espacio={3}>
            <p>{t.errorCarga}</p>
            <div>
              <Button variante="secundario" onClick={t.reintentar}>
                Reintentar
              </Button>
            </div>
          </Stack>
        </Card>
      )}
      {t.form && (
        <form onSubmit={(e) => void t.guardar(e)} noValidate>
          <Stack espacio={6}>
            <Card>
              <Stack espacio={4}>
                <h2 className="text-titulo font-light tracking-tight">General</h2>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <TextField etiqueta="Nombre" {...campo("nombre")} />
                  <TextField etiqueta="CUIT" placeholder="30-12345678-9" inputMode="numeric" {...campo("cuit")} />
                  <TextField etiqueta="Dirección de la obra" {...campo("direccion")} />
                  <TextField etiqueta="Fecha de constitución" placeholder="dd/mm/aaaa" inputMode="numeric" {...campo("fecha_constitucion")} />
                </div>
              </Stack>
            </Card>
            <Card>
              <Stack espacio={4}>
                <h2 className="text-titulo font-light tracking-tight">Fiduciario</h2>
                <p className="text-chico text-texto-suave">Quien administra el fideicomiso y cobra los honorarios (el fee) sobre cada gasto.</p>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <TextField etiqueta="Nombre del fiduciario" placeholder="Ej.: Matsu Desarrollos SRL" {...campo("fiduciario_nombre")} />
                  <TextField etiqueta="CUIT del fiduciario" placeholder="30-12345678-9" inputMode="numeric" {...campo("fiduciario_cuit")} />
                  <TextField
                    etiqueta="Honorarios del fiduciario (%)"
                    inputMode="decimal"
                    ayuda="Se aplican por defecto a cada gasto"
                    {...campo("fee_porcentaje")}
                  />
                </div>
              </Stack>
            </Card>
            <Card>
              <Stack espacio={4}>
                <h2 className="text-titulo font-light tracking-tight">Datos bancarios</h2>
                <p className="text-chico text-texto-suave">Los ven los fiduciantes para transferir sus aportes.</p>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <TextField etiqueta="Banco" {...campo("banco")} />
                  <TextField etiqueta="CBU o alias (ARS)" {...campo("cbu_alias_ars")} />
                  <TextField etiqueta="Cuenta en USD" {...campo("cuenta_usd")} />
                </div>
              </Stack>
            </Card>
            <Alerta texto={t.error} />
            {t.guardado && (
              <p role="status" className="rounded-control bg-exito-suave px-3 py-2 text-chico text-exito">
                Cambios guardados
              </p>
            )}
            <div>
              <Button type="submit" cargando={t.guardando}>
                Guardar
              </Button>
            </div>
          </Stack>
        </form>
      )}
    </Stack>
  );
}
